import { render, staticRenderFns } from "./ProofreadingSelectChecks.vue?vue&type=template&id=200b3968&scoped=true"
import script from "./ProofreadingSelectChecks.vue?vue&type=script&lang=ts"
export * from "./ProofreadingSelectChecks.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingSelectChecks.vue?vue&type=style&index=0&id=200b3968&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b3968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200b3968')) {
      api.createRecord('200b3968', component.options)
    } else {
      api.reload('200b3968', component.options)
    }
    module.hot.accept("./ProofreadingSelectChecks.vue?vue&type=template&id=200b3968&scoped=true", function () {
      api.rerender('200b3968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/proofreading/ProofreadingSelectChecks.vue"
export default component.exports